// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import type { ValidationRules } from "@lg/shared";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { ProxyTargetSymbol } from "@lg/shared/for-apps";
import { Semaphore } from "@lg/shared/for-apps";
import { memoize } from "@lg/shared/for-apps";
import { NgSharedModule } from "@lg/ng-shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";
import { MatButtonModule } from "@angular/material/button";
import { GenericTableComponent } from "@lg/ng-shared";
import { MatTableModule } from "@angular/material/table";

interface Properties {
    myTasks: Sys.Types.UserTaskToken[];
    teamTasks: Sys.Types.UserTaskToken[];
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Orders-Tasks',
    templateUrl: './Tasks.html',
    styleUrls: ['./Tasks.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgSharedModule,
        MatButtonModule,
        GenericTableComponent,
        MatTableModule
    ],
})
export class Tasks extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Orders.Tasks';
    $isDialog = false;
    $Modules = $Modules;
    Orders = Orders;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    _DataTableBlock_columns_8 = (screen: Properties) => ['taskName', 'customer', 'items'];
    _DataTableBlock_columns_11 = (screen: Properties) => ['taskName', 'customer', 'items'];
    $validators: Record<number, ValidationRules> = {

    };
    var_myTasks = proxySignal<Sys.Types.UserTaskToken[]>(undefined as any);
    var_teamTasks = proxySignal<Sys.Types.UserTaskToken[]>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get myTasks() { return component.var_myTasks() },
                set myTasks(value: Sys.Types.UserTaskToken[]) { component.var_myTasks.set(value) },
                get teamTasks() { return component.var_teamTasks() },
                set teamTasks(value: Sys.Types.UserTaskToken[]) { component.var_teamTasks.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {

        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this
            if (!isVariablesInitialized) this.screen.myTasks = ([])
            if (!isVariablesInitialized) this.screen.teamTasks = ([])
            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })

        this.router.events.pipe(
            filter(e => e instanceof NavigationSkipped),
            takeUntilDestroyed(),
        ).subscribe(() => {
            this.action_onNavigationSkipped(null)
        })

    }

    async handler_ButtonBlock_27_click_reloadTasks_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                await this.action_reloadTasks($event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_DataTableBlock_8_rowClick_onTaskClick_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {
            let item: Sys.Types.UserTaskToken = $event[1], index: number = $event[2]
            const { app, screen, output } = this
            try {
                await this.action_onTaskClick(item, $event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    _DataTableBlock_collectionCodeSignal_8(component: any, $scope: any): any {

        return this.getMemoizedSignal(component, 'collectionCode', () =>
            computed(() => {
                let { app, screen, $pathSegments, $disabled }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean } = $scope ?? {}
                return (screen.myTasks)
            }, { equal: () => false })
        )

    }

    _DataTableColumnBlock_cellText_9($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: Sys.Types.UserTaskToken, index: number } = $scope ?? {}

        return (item.taskName)
    }

    _DataTableColumnBlock_cellText_29($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: Sys.Types.UserTaskToken, index: number } = $scope ?? {}

        return (item.publicMetadata.customer)
    }

    _DataTableColumnBlock_cellText_30($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: Sys.Types.UserTaskToken, index: number } = $scope ?? {}

        return (item.publicMetadata.items)
    }

    async handler_DataTableBlock_11_rowClick_onTaskClick_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {
            let item: Sys.Types.UserTaskToken = $event[1], index: number = $event[2]
            const { app, screen, output } = this
            try {
                await this.action_onTaskClick(item, $event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    _DataTableBlock_collectionCodeSignal_11(component: any, $scope: any): any {

        return this.getMemoizedSignal(component, 'collectionCode', () =>
            computed(() => {
                let { app, screen, $pathSegments, $disabled }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean } = $scope ?? {}
                return (screen.teamTasks)
            }, { equal: () => false })
        )

    }

    _DataTableColumnBlock_cellText_12($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: Sys.Types.UserTaskToken, index: number } = $scope ?? {}

        return (item.taskName)
    }

    _DataTableColumnBlock_cellText_31($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: Sys.Types.UserTaskToken, index: number } = $scope ?? {}

        return (item.publicMetadata.customer)
    }

    _DataTableColumnBlock_cellText_32($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: Sys.Types.UserTaskToken, index: number } = $scope ?? {}

        return (item.publicMetadata.items)
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {
            Sys.App.title = 'Task list'

            this.action_reloadTasks($event)
        }
    }

    async action_onTaskClick(selectedTask: Sys.Types.UserTaskToken, $event?: any) {
        const { app, screen, output } = this
        {
            await Sys.Process.navigateToTask(selectedTask, false)
        }
    }

    async action_reloadTasks($event?: any) {
        const { app, screen, output } = this
        {
            const myTasksPromise = Sys.Process.getAllTasksForUser({ includeUserAllowed: true, includeAssigned: true })
            const teamTasksPromise = Sys.Process.getAllTasksForUser({ includeRoleAllowed: true })

            screen.myTasks = await myTasksPromise
            screen.teamTasks = await teamTasksPromise
        }
    }

    async action_onNavigationSkipped($event?: any) {
        const { app, screen, output } = this
        {
            await this.action_reloadTasks()
            Sys.App.showSuccess('Tasks reloaded')
        }
    }
}
